module.exports = __webpack_public_path__ + "school/img/freeResourcesBg.3406261c.jpg";